import styled from "styled-components";
import { colors } from "../../../../theme/theme";

export const PrivacyWrapper = styled.div`
	padding: 0 12px;

	h2 {
		color: ${colors.mainColors.blueberry};
		font-size: 24px;
		font-weight: 700;
		margin-bottom: 36px;
	}

	> h2 {
		padding-bottom: 16px;
		border-bottom: 1px solid ${colors.greyscale.grey};
		margin: 0;
	}
`;

export const PrivacySection = styled.div`
	margin: 24px auto;
	width: 100%;
	max-width: 940px;
	border-radius: 8px;
	background: ${colors.greyscale.white};
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

	.title {
		padding: 22px 60px 16px;

		font-size: 22px;
		color: ${colors.greyscale.black};
		font-weight: 600;

		border-bottom: 1px solid ${colors.greyscale.light_grey};
	}

	.content {
		color: ${colors.greyscale.darker_grey};
		padding: 24px 60px;
	}
`;
